const React = require('react');
const PropTypes = require('prop-types');

const showGDI = require('core/environmentConfig').GDI;

class CmToggle extends React.Component {
    render() {
        return showGDI ? this.props.children : null;
    }
}

CmToggle.propTypes = {
    children: PropTypes.element.isRequired,
};

module.exports = CmToggle;
